export default __webpack_public_path__ + "static/media/2479.19d0eeee.png";